import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {getOrder, updateOrder} from '../../order';
import {getStep, nextStep} from '../../steps';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import styles from './css/Additions.scss';
import {withRouter} from "react-router-dom";
import {selectAdditions} from "../../../app/additions";
import AdditionsForm from "./additions/Form";
import ValidationErrors from "../../components/ValidationErrors";
import {fromJS} from "immutable/dist/immutable";

export class AdditionsStep extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        additions: ImmutablePropTypes.list.isRequired,
        order: ImmutablePropTypes.map.isRequired,
        currentStep: ImmutablePropTypes.map.isRequired,
    }

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    handleSubmit = (values) => {
        console.log(values.toJS());
        const { order, dispatch } = this.props;
        const newOrder = order.set('additions', values);
        dispatch(updateOrder(newOrder));
        this.handleNextStep();
    }

    handleNextStep = () => {
        const {dispatch, currentStep} = this.props;
        dispatch(nextStep(currentStep));
    }

    render() {
        const {currentStep, additions, dispatch} = this.props;
        return (
            <div>
                <Sticky top='#page-header' innerZ={98}>
                    <div className={styles.container}>
                        <h2 className={styles.headline}>
                            <FormattedMessage
                                id='frontend.form_additions.headline'
                            />
                        </h2>
                        <ValidationErrors errors={currentStep.get('errors')} status={currentStep.get('state')}>
                            <FormattedMessage id='frontend.form_additions.validation.has_errors'/>
                        </ValidationErrors>
                        {additions && !additions.isEmpty()
                            ? <AdditionsForm.Component
                                dispatch={dispatch}
                                onSubmit={this.handleSubmit}
                                additions={additions}>
                            </AdditionsForm.Component>
                            : <div>No additions loaded yet.</div>
                        }
                    </div>
                </Sticky>
            </div>
        );

    }
}

export default withRouter(connect(state => ({
    order: getOrder(state),
    currentStep: getStep(state, 'additions'),
    additions: selectAdditions(state),
}))(AdditionsStep));
